<template>
  <div>
    <!-- list -->
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
      <div class="aui-content aui-margin-b-15">
        <ul class="aui-list aui-media-list" v-for="(item,i) in comments" :key="i">
          <li class="aui-list-item" @click="getNews(item.id,i)">
            <div class="aui-media-list-item-inner">
              <div class="aui-list-item-media maui-buy-media">
                <img :src="item.pictureUrl" />
              </div>
              <div class="aui-list-item-inner maui-buy-rightbox">
                <div class="aui-list-item-text maui-flex-start">
                  <div class="maui-goods-name">{{item.title}}</div>
                  <div class="maui-goods-class">
                    <span
                      v-for="(desc,index) in (item.goodsClassName||'').split('-')"
                      :key="desc.id"
                    >
                      <span :title="item.goodsClassName" v-if="index==0">{{desc}}</span>
                    </span>
                  </div>
                </div>
                <div class="aui-list-item-text maui-flex-start">
                  <div
                    v-if="item.estimatedPrice!=''"
                    class="maui-goods-price"
                  >期望价格：{{item.estimatedPrice}}元</div>
                  <div v-else class="maui-goods-price">期望价格：面谈</div>
                  <div class="maui-goods-l">{{item.number}}{{item.unit}}</div>
                </div>

                <div class="aui-list-item-text maui-goods-thredbox">
                  <div class="maui-goods-l2">
                    <span
                      v-for="(desc,index) in (item.goodsClassName||'').split('-')"
                      :key="desc.id"
                    >
                      <span :title="item.goodsClassName" v-if="index==1">{{desc}}</span>
                      <span :title="item.goodsClassName" v-if="index==2">-{{desc}}</span>
                    </span>
                  </div>
                  <i class="aui-iconfont aui-icon-right"></i>
                </div>
                <div class="aui-list-item-text">
                  <div class="maui-goods-ad">
                    <i class="aui-iconfont aui-icon-location"></i>
                    {{item.area}}
                  </div>
                  <div class="maui-goods-data">{{item.createDate | datefmt('MM/DD')}}</div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </van-list>
    <!-- list end-->
  </div>
</template>

<script>
export default {
  name: "purchasingList",
  data() {
    return {
      //noDate: false,//这是一个判断是否加载的开关
      arr: [],
      showPage: 1,
      pageSize: 4,
      comments: [],
      pageindex: 1,
      loading: false,
      totalElements: "",
      finished: false,
      estimatedPrice: ""
    };
  },
  // created() {
  //    this.getComments();
  // },
  methods: {
    onLoad() {
      this.$axios
        .get(
          "/micro/permission_order-view/need/read/query?pageNo=" +
            this.pageindex +
            "&pageSize=&sort=0&goodsClassId=&kyeWord"
        )
        .then(res => {
          // this.comments = result.body.message;
          // 不替换老数据
          console.log(
            "res.data.data.supplyList==================" +
              res.data.data.supplyList
          );
          this.comments = this.comments.concat(res.data.data.needList);
          this.totalElements = res.data.data.totalElements;
        }); // 异步更新数据
      setTimeout(() => {
        // 异步滑动加载数据
        this.getMore(); // 加载状态结束
        this.loading = false;
        console.log(
          "this.comments.length==================" + this.comments.length
        );
        console.log(
          "this.totalElements.length==================" + this.totalElements
        );
        if (this.comments.length >= this.totalElements) {
          this.finished = true;
        }
      }, 2000);
    },
    // onRefresh() {
    //       setTimeout(() => {
    //         this.$toast('刷新成功');
    //         this.isLoading = false;
    //         this.count++;
    //       }, 500);
    //     },

    getMore() {
      console.log("this.pageindex==================" + this.pageindex);
      this.pageindex++;
    },
    getNews(item, i) {
      console.log(item);
      this.$router.push({ path: "/purchasingform", query: { xqid: item } });
    }
  }
};
</script>

<style scoped>
.maui-bar.aui-bar-nav {
  background-color: #fff;
  color: #000;
  border-bottom: solid 0.1rem #efefef;
}
.aui-label-outlined.aui-label-danger,
.aui-label-outlined.aui-label-danger::after {
  border: solid 0.1rem #c9eee1;
  color: #3bb18a;
}
.aui-bar-nav .aui-btn .aui-iconfont {
  color: #000;
  font-weight: bold;
}
.aui-list {
  background: none;
}
.aui-list .aui-list-item-title.maui-news-tit {
  height: 2rem;
  line-height: 1rem;
  font-size: 0.75rem;
  color: #4f4f4f;
  overflow: hidden;
}
.aui-list .aui-list-item-text.maui-data {
  font-size: 0.65rem;
  margin: 0.2rem 0;
  color: #4f4f4f;
  justify-content: flex-end;
}

.aui-media-list .aui-list-item-inner.maui-buy-rightbox {
  border-bottom: solid 0.05rem #e0e0e0;
  padding: 0;
  margin: 0.7rem 0.75rem 0.7rem 0.2rem;
}
.aui-list .aui-list-item-media.maui-buy-media {
  width: 4.75rem;
  padding-top: 0.7rem;
  padding-bottom: 0.7rem;
}
.aui-list .aui-list-item-media.maui-buy-media img {
  width: 4rem;
  height: 5rem;
  border-radius: 0.2rem;
  border: solid 0.05rem #e0e0e0;
}

.aui-list .aui-list-item-text.maui-flex-start {
  justify-content: flex-start;
  margin-bottom: 0.2rem;
}
.maui-search.aui-searchbar {
  background-color: #fff;
}
.maui-search .aui-searchbar-input {
  background-color: #f8f8f8;
  display: flex;
  justify-content: space-between;
  border-radius: 0.75rem;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
}
.maui-search .aui-searchbar-cancel {
}
.maui-search button {
  background: none;
  border: none;
  cursor: pointer;
}
.maui-goods-name {
  font-size: 0.75rem;
  color: #4f4f4f;
  margin-right: 0.5rem;
}
.maui-goods-class {
  font-size: 0.65rem;
  color: #9779ef;
  border: solid 0.05rem #;
}
.maui-goods-price {
  font-size: 0.65rem;
  color: #4f4f4f;
  margin-right: 0.5rem;
}
.maui-goods-l {
  font-size: 0.65rem;
  color: #9779ef;
  border: solid 0.05rem #9779ef;
  padding: 0 0.2rem;
  border-radius: 0.2rem;
}
.maui-goods-l2 {
  font-size: 0.65rem;
  color: #4f4f4f;
}
.aui-list .aui-list-item-text.maui-goods-thredbox i {
  font-size: 0.6rem;
  color: #4f4f4f;
}
.maui-goods-ad {
  font-size: 0.6rem;
  color: #4f4f4f;
}
.maui-goods-ad i {
  font-size: 0.6rem;
  color: #000;
  margin-right: 0.2rem;
}
.maui-goods-data {
  font-size: 0.6rem;
  color: #4f4f4f;
}

.aui-list .aui-list-item {
  background: none;
  border: none;
}

@media only screen and (max-width: 768px) {
  .aui-list .maui-textmore-item .aui-list-item-label {
    width: 100%;
  }
}
@media only screen and (max-width: 480px) {
  .aui-list .aui-list-item-label,
  .aui-list .aui-list-item-label-icon {
    width: 49%;
  }
  .aui-list .maui-textmore-item .aui-list-item-label {
    width: 100%;
  }
}
@media only screen and (max-width: 320px) {
  .aui-list .aui-list-item-label,
  .aui-list .aui-list-item-label-icon {
    width: 40%;
    font-size: 0.6rem;
  }
  .aui-list .maui-textmore-item .aui-list-item-label {
    width: 70%;
    font-size: 0.6rem;
  }
  .aui-input,
  input[type="text"],
  input[type="password"],
  input[type="search"],
  input[type="email"],
  input[type="tel"],
  input[type="url"],
  input[type="date"],
  input[type="datetime-local"],
  input[type="time"],
  input[type="number"],
  select,
  textarea {
    font-size: 0.6rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/purchasingList.vue